// 这里需要引入vuex
import store from "../store";

let WS = {
  $ws: null,
  lockReturn: false,
  timeout: 60 * 1000 * 5, // 心跳时间
  timeoutObj: null, // 心跳Interval 对象
  timeoutNum: null, // 重连Timeout 对象
  serverTimeoutObj: null,
  // 初始化webSocket长连接
  initWebSocket: function() {
    this.$ws = new WebSocket("ws://trade.zrtek.com.cn/v1/ws"); // 写入地址 这里的地址可以在initWebSocket方法加入参数
    this.$ws.onopen = this.wsOpen;
    this.$ws.onclose = this.wsClose;
    this.$ws.onmessage = this.wsMsg;
    this.$ws.onerror = this.wsError;
  },
  sendSocket: function(data) {
    console.log("------sendSocket------");
    if (this.$ws.readyState === 1) {
      this.$ws.send(JSON.stringify(data));
    } else {
      setTimeout(() => {
        console.log(this.$ws, "等待socket链接成功");
        this.sendSocket(data);
      }, 1500);
    }
  },
  // 打开websocket
  wsOpen: function(e) {
    // 开始websocket心跳
    WS.startWsHeartbeat();
    console.log("ws wsOpen success");
  },
  wsClose: function(e) {
    console.log(e, "ws close");
  },
  wsMsg: function(msg) {
    let dataJson = JSON.parse(msg.data);
    var buffer = dataJson.buffer;
    // console.log('buffer------', buffer)
    // console.log('!buffer', !buffer)
    // console.log('typeof (buffer) !== undefined', typeof (buffer) !== 'undefined')
    // 服务端发送来的消息存到vuex
    if (buffer && typeof buffer !== "undefined") {
      // console.log('buffer2------', buffer)
      store.commit("setWebsocketmsg", buffer);
    }
    // 每次接收到服务端消息后 重置websocket心跳
    // WS.resetHeartbeat()
  },
  wsError: function(err) {
    console.log(err, "ws error");
    WS.reconnect();
  },
  websocketClose: function() {
    if (this.$ws !== null) {
      this.$ws.close();
    }
  },
  // 重启websocket
  reconnect: function() {
    let _this = this;
    if (_this.lockReturn) {
      return;
    }
    _this.lockReturn = true;
    _this.timeoutNum && clearTimeout(_this.timeoutNum);
    _this.timeoutNum = setTimeout(function() {
      _this.initWebSocket();
      _this.lockReturn = false;
    }, 3000);
  },
  // 心跳
  startWsHeartbeat: function() {
    let _this = this;
    _this.timeoutObj && clearTimeout(_this.timeoutObj);
    _this.serverTimeoutObj && clearTimeout(_this.serverTimeoutObj);
    _this.timeoutObj = setInterval(function() {
      // 判断websocket当前状态
      if (_this.$ws.readyState !== 1) {
        _this.reconnect();
      } else {
        let data = {
          op: "ping",
          timestamp: new Date().getTime()
        };
        _this.$ws.send(JSON.stringify(data));
      }
    }, _this.timeout);
  },
  // 重置websocket心跳
  resetHeartbeat: function() {
    let _this = this;
    clearTimeout(_this.timeoutObj);
    clearTimeout(_this.serverTimeoutObj);
    _this.startWsHeartbeat();
  }
};

// 抛出websocket对象
export default WS;
